exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mr-site-search {\n  max-height: 0;\n  overflow: hidden;\n}\n.mr-site-search .search-wrap {\n  display: none;\n}\n.mr-site-search.open {\n  max-height: 30em;\n  box-shadow: 0px 2px 6px #eaeaea;\n}\n.mr-site-search.open .search-wrap {\n  display: block;\n}\n.mr-site-search.open .search-wrap .input-wrap {\n  padding: 0;\n  border: none;\n}\n.mr-site-search.open .search-wrap .input-wrap input#site-search {\n  padding-left: 0.5em;\n  border: 1px solid #ccc;\n  font-size: 16px;\n}\n.mr-site-search.open .search-wrap .input-wrap .search-input {\n  font-size: 1em;\n  height: 44px;\n}\n", ""]);

// exports
